
import Loading from 'vux/src/components/loading/index.vue'

import { mapGetters } from "vuex";

export default {
name: "app",
components: {
Loading
},
data() {
return {
title: ""
};
},
mounted() {
window.onpopstate = () => {};
},
computed: {
...mapGetters(["isLoading"])
},
methods: {
setTitle(t) {
document.title = t;
var i = document.createElement("iframe");
i.src = "//m.baidu.com/favicon.ico";
i.style.display = "none";
i.onload = function() {
setTimeout(function() {
i.remove();
}, 9);
};
document.body.appendChild(i);
}
},
watch: {
$route: {
handler: function(route) {
if (route.path === "/login") {
this.$nextTick(() => {
this.setTitle(route.meta.title);
});
} else {
this.title = route.meta.title;
}
},
immediate: true
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue